import React from "react"
import {useQuery} from "graphql-hooks"
import {GET_LG_POI} from "../../gql/gqlLocGroups"
import {Spinner} from "../../components/Spinner/index"
import InternalError from "../../components/InternalError"
import Locations from "../../components/Locations"
import {UseStores} from "../../hooks/UseStores"
import queryString from "query-string"
import {observer} from "mobx-react-lite"

const LGLocations = (props) => {
  const {navStore} = UseStores()
  const {name, tagId, geoType, geoId} = queryString.parse(props.location.search)
  const geo = {geoType, geoId}
  const {loading, data, error} = useQuery(GET_LG_POI, {
    variables: {tagId, geo},
  })

  navStore.setLocationGroupName(name)

  if (loading) return <Spinner />
  if (error) return <InternalError />

  return (
    <div data-testid="loc-group-poi" className="brand-location-container">
      {data ? <Locations data={data.getLocationGroupPois} /> : ""}
    </div>
  )
}
export default observer(LGLocations)
